import React from "react";
import Button from "../base/button";

const SubNavigationItem = (subNavigations) => {
  return subNavigations.map((subNavigation, subNavigationIndex) => (
    <li key={"sub_navigation_index_" + subNavigationIndex}>
      <ul>
        <li key={"sub_naviation_button_wrap_index_" + subNavigationIndex}>
          <Button
            type="navigation-card"
            href={subNavigation.url}
            text={subNavigation.title}
            wrapper={false}
          />
        </li>
        {subNavigation.subNavigationItems.map(
          (subNavigationItem, subNavigationItemIndex) => (
            <li key={subNavigationItemIndex + "_sub_navigation_item"}>
              <Button
                type="navigation-card"
                href={subNavigationItem.url}
                text={subNavigationItem.title}
                wrapper={false}
              />
            </li>
          )
        )}
      </ul>
    </li>
  ));
};

export default SubNavigationItem;
